// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-pages-EntityFiltersPage-AsyncTableView-templates-ATVFreezeLine-ATVFreezeLine-module__item--WAeRR {
  position: sticky;
  top: 0;
}
.src-pages-EntityFiltersPage-AsyncTableView-templates-ATVFreezeLine-ATVFreezeLine-module__last--_xort {
  box-shadow: 9px 0px 5px -1px #e2e2e2;
}
`, "",{"version":3,"sources":["webpack://./src/pages/EntityFiltersPage/AsyncTableView/templates/ATVFreezeLine/ATVFreezeLine.module.less"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,MAAA;AACF;AAEA;EACE,oCAAA;AAAF","sourcesContent":[".item {\n  position: sticky;\n  top: 0;\n}\n\n.last {\n  box-shadow: 9px 0px 5px -1px rgba(226, 226, 226, 1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"item": `src-pages-EntityFiltersPage-AsyncTableView-templates-ATVFreezeLine-ATVFreezeLine-module__item--WAeRR`,
	"last": `src-pages-EntityFiltersPage-AsyncTableView-templates-ATVFreezeLine-ATVFreezeLine-module__last--_xort`
};
export default ___CSS_LOADER_EXPORT___;
